var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(1.66333 1.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66333 1.5C7.27886 1.5 5.92548 1.91054 4.77434 2.67971C3.6232 3.44888 2.72599 4.54213 2.19618 5.82121C1.66636 7.1003 1.52774 8.50776 1.79784 9.86563C2.06793 11.2235 2.73462 12.4708 3.71359 13.4497C4.69255 14.4287 5.93983 15.0954 7.2977 15.3655C8.65557 15.6356 10.063 15.497 11.3421 14.9672C12.6212 14.4373 13.7144 13.5401 14.4836 12.389C15.2528 11.2378 15.6633 9.88447 15.6633 8.5C15.6633 6.64348 14.9258 4.86301 13.6131 3.55025C12.3003 2.2375 10.5198 1.5 8.66333 1.5Z",
    stroke: "black",
    strokeWidth: 1.61346,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43604 6.3634C6.43604 6.3634 6.46944 5.66738 7.21439 5.068C7.65626 4.71203 8.18603 4.60902 8.66331 4.60186C9.09802 4.5963 9.4862 4.66828 9.71848 4.77885C10.1162 4.96817 10.8906 5.43033 10.8906 6.41311C10.8906 7.4472 10.2144 7.91692 9.44405 8.43357C8.67365 8.95021 8.46444 9.51101 8.46444 10.0905",
    stroke: "black",
    strokeWidth: 1.41178,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42485 12.9542C8.86417 12.9542 9.2203 12.5981 9.2203 12.1587C9.2203 11.7194 8.86417 11.3633 8.42485 11.3633C7.98553 11.3633 7.62939 11.7194 7.62939 12.1587C7.62939 12.5981 7.98553 12.9542 8.42485 12.9542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/other-icon.e3b1e70c53c3d069ad482af5bacd51fe.svg";
export { ForwardRef as ReactComponent };